module.exports = __webpack_public_path__ + "static/media/value-poster-6.48240ecb.png";